import { ToastActionTypes, TOAST_MESSAGE } from "../actions/toast.actions";

const initialState = {
  message: ""
};
export const ToastReducer = (
  state = initialState,
  action: ToastActionTypes
) => {
  switch (action.type) {
    case TOAST_MESSAGE:
      return action.payload;
    default:
      return state;
  }
};
